var map = {
	"./Logo.svg": 562,
	"./beslenme.svg": 453,
	"./check.svg": 809,
	"./davranis.svg": 807,
	"./emzirme.svg": 697,
	"./gelisim.svg": 106,
	"./growth.svg": 578,
	"./health.svg": 109,
	"./objects.svg": 561,
	"./oyun.svg": 157,
	"./uyku.svg": 821
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 57;